module.exports = (__webpack_require__("JWh9G"))("edSLo");